
import { ParsedPhoneNumber } from 'awesome-phonenumber';
import BigNumber from 'bignumber.js';
import { Account, Token } from '../services/stellar/wallet-sdk/types';
import { Memo, MemoType } from '@stellar/stellar-sdk';
import { Horizon } from '@stellar/stellar-sdk';
import * as cs from '@cubist-labs/cubesigner-sdk';

export type RawWalletInfo = {

  mnemonic: string;
  public_key: string;
  private_key: string;
}

export type WalletInfoState = {
  info: any;
  has_key: boolean;
  account_key: string | null;
  account_private_key: string | null;
  device_key: string | null,
  device_private_key: string | null;
  mnemonic?: string | null
}

export type EncryptWalletKeysParams = {
  password: string,
  language?: string,
  walletData?: RawWalletInfo
}

export type StellarDataProviderType = {
  serverUrl: string;
  accountOrKey: string;
}

export type StellarApiType = {
  initStellarApiProvider: any;
  getAccountDetails: any;

}

export type UserInfo = {

  id: string,
  first_name: string,
  last_name: string,
  email: string,
  is_email_verified: boolean,
  mobile_number: string,
  is_mobile_number_verified: boolean
  country_code2: any,
  calling_code: string,
  locale: string,
  notification_id: string,
  currency_code: string,
  stellar_public_key: string,
  email_federation_address: string;
  mobile_federation_address: string;
  allowedNotification: boolean,
  invite_code: string,
  kyc_status_crypto: string;
  kyc_status_fiat: string;
  paymentId: string;
  proof_of_residence_id: any;

}

export type EncryptedKey = {
  encryptedBlob: string;
  encrypterName: string;
  id: string;
  salt: string;
  network?:string;
}

export type KeyMetadata = {
  id: string;

}

export type Sep10ChallengeParams = {
  account: string;
  home_domain: string;
  network: string;
  privateKey: string;
  memo?: string;
  client_domain?: string;
  client_domain_jwt?:string;

}

// export type Sep10AuthParams = {

//     id: string;                           
//     password: string;
//     authServer: any;
//     authServerKey:any;
//     account?: string;
//     authServerHomeDomains:string[],
//     clientDomain?:string
// }

export type Asset = {
  name: string,
  code: string,
  display_code: string,
  symbol: string,
  home_domain: string,
  icon: string,
  identifier: string,
  type: string,
  issuer_name: string,
  issuer_terms?: string,
  buy_enabled:boolean,
  sell_enabled:boolean,
  providers:{
    buy: string[],
    sell: string[]
  }
  // buy_enabled_moonpay: boolean,
  // sell_enabled_moonpay: boolean,
  sep6_deposit_type: string;
  decimal_places: number;
  deposit_enabled: boolean;
  withdraw_enabled: boolean;
  deposit_withdraw_note?: string,
  sep_31: boolean;
  sep_24: boolean;
  buy_sell_provider: string;
  coingecko_id: string;
  description: any;
  convert_to_cash: boolean,
  topups_enabled:boolean
  sponsor_trust_line:boolean,
  remittances_enabled:boolean,
  trade_enabled:boolean;
}

export type AnchorTransactionHistoryOptions = {
  asset_code: string;
  no_older_than?: Date;
  limit?: number;
  kind?: string;
  paging_id?: string;
}

export type AnchorPayment = {

  id: string;
  kind: string;
  status: string;
  status_eta?: number;
  kyc_verified?: boolean;
  more_info_url: string;
  amount_in: string;
  amount_out: string;
  amount_fee: string;
  started_at: Date;
  completed_at: Date;
  stellar_transaction_id: string;
  external_transaction_id?: string;
  message?: string;
  refunded: boolean;
  deposit_memo?: string;
  deposit_memo_type?: string;
  from: string;
  to: string;
  withdraw_anchor_account?: string;
  withdraw_memo?: string;
  withdraw_memo_type?: string;
}

export type OperationObject = {

  operation: Operation;
  destination: string;
  asset?: Asset;
  amountOut?: string;
  memo?: string;
  memoType?: string;
  msg?: string;

}

export type CollectionParams = {
  limit?: number;
  order?: "desc" | "asc";
  cursor?: string;
}


export type DisplayableOperation = {
  id: string;
  isInitialFunding: boolean;
  isRecipient: boolean;
  token: Token;
  amount: BigNumber;
  timestamp: number;
  otherAccount: Account;
  sourceToken?: Token;
  sourceAmount?: BigNumber;
  transactionId: string;
  type: Horizon.HorizonApi.OperationResponseType;
  memo?: Memo | string;
  memoType?: MemoType;
  claimable_balance_id?: string;
  claim_abs_before?: string;
  claim_not_abs_before?: string;
  claim_rel_before?: string;
  claim_unconditional?: boolean;
  //mergedAccount?: Account;
  description?: string;
  name?: string;
  hidden?: boolean;
  liquidity_pool_id?: string;
  reserves_received?: any[];
  reserves_deposited?: any[];
  kind?:string;
  info?:any|null;

}

export type Sep10TokenRequestItem = {
  home_domain: string
  password: string
}

export type JWTToken = {
  home_domain: string;
  token: string;
}

export enum Operation {
  SEND = 'send',
  RECEIVE = 'receive',
  BUY = 'buy',
  TRADE = 'trade',
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
  SELL = 'sell',
}

export type DelegateSigningParams = {

  uri: string,
  account: string;
  asset_code?: string,
  asset_issuer?: string
  name?:string;
  msg?:string;
  fees?:string;

}

export type BuyWidgetParams = {
  assetCode: string;
  baseCurrencyCode: string;
  provider: string;
  baseCurrencyAmount?: number
}

export type SellWidgetParams = {
  assetCode: string;
  baseCurrencyCode: string;
  provider: string;
  baseCurrencyAmount?: number;
}

export type DelegateSigningTx = {

  stellar_account: string;
  sep0007_uri: string;
  xdr: string;
  status: string;
  asset_code: string;
  hash: string;
  stellar_transaction_id: string;
  description?: string,
  createdAt: string,
  updatedAt: string
}

export type PendingTxParams = {
  asset_code: string,
  limit: number,
  paging_id?: string,
}

export type PendingTransaction = {
  id: string;
  createdAt: string;
  updatedAt: string;
  stellar_account: string;
  status: string;
  kind: string;
  xdr: string;
  description: string;
  amount_in: string;
  asset_code: string;

}

export enum ActionStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export interface AggregatedPoolsInitialState {
  data: LiquidityPoolDetails[];
  status: ActionStatus | undefined;
  errorString?: string;
}

export interface PoolDetailsInitialState {
  data: LiquidityPoolDetails | null;
  status: ActionStatus | undefined;
  errorString?: string;
}
export interface PoolTransactionsInitialState {
  data: LiquidityPoolTransaction[];
  status: ActionStatus | undefined;
  errorString?: string;
}

export interface PoolHistoryInitialState {
  data: LiquidityPoolHistory[];
  status: ActionStatus | undefined;
  errorString?: string;
}

export interface LiquidityPoolAsset {
  asset: string;
  assetCode?: string;
  amount?: string | number;
  "1d"?: string | number;
  "7d"?: string | number;
  // eslint-disable-next-line camelcase
  all_time?: string | number;
}

// Liquidity pool
export interface LiquidityPoolReserve extends LiquidityPoolAsset {
  amount: string | number;
}

export interface LiquidityPoolAssetInterval extends LiquidityPoolAsset {
  "1d": string | number;
  "7d": string | number;
  // eslint-disable-next-line camelcase
  all_time: string | number;
}

export interface LiquidityPoolOperation {
  [key: string]: any;
  id: string;
  type: string;
  /* eslint-disable camelcase */
  created_at: string;
  transaction_hash: string;
  liquidity_pool_id: string;
  reserves_deposited: LiquidityPoolReserve[];
  shares_received: string;
  /* eslint-enable camelcase */
}

export interface LiquidityPoolTransaction {
  id: string;
  liquidityPoolId: string;
  createdAt: string;
  shares: string;
  reserves: LiquidityPoolReserve[];
  transactionHash: string;
  type: string;
}

export type LiquidityPoolHistory = {
  ts: number;
  totalValueLocked: number;
};

export interface AssetAvatar {
  altText: string;
  iconUrl: string | undefined;
}

export interface LiquidityPoolDetails {
  id: string;
  assets: LiquidityPoolReserve[];
  fee: number;
  assetCodes: string[];
  assetAvatars: AssetAvatar[];
  totalShares: number;
  totalAccounts: string;
  totalTrades: string;
  totalValueLocked: number;
  earnedFees: LiquidityPoolAssetInterval[];
  earnedValue: LiquidityPoolAssetInterval,
  volume: LiquidityPoolAssetInterval[];
  volumeValue: LiquidityPoolAssetInterval
}

// Chart
export interface ChartData {
  x: string;
  y: number;
}

// Table
export enum SortOrder {
  asc = "asc",
  desc = "desc",
}

export interface DestinationUserName {
  name?: string,
  username?: string
}
export interface PaymentDestinationInfo {
  destination_address: string | undefined,
  destination_asset: Asset | undefined,
  destination_amount: string | undefined,
  destination_memo?: string,
  destination_memo_type?: string,
  destination_username?: DestinationUserName
  message?: string;
  destination_fee_address?: string;
  destination_fee_amount?:string;
}

export interface CoinGeckoCoinsMarketParams {

  vs_currency: string;
  ids?: string;
  category?: string;
  order?: string;
  per_page?: number;
  page?: number;
  sparkline?: boolean,
  price_change_percentage?: string


}

export interface CoinGeckoCoinMarketChartParams {

  id: string;
  vs_currency: string;
  days: string;
  interval?: string;

}

export enum ChartTimeFilters {
  P1D = "1",
  P7D = "7",
  P1M = "30",
  P3M = "90",
  P6M = "180",
  P1Y = "365",
}

export interface ChartDataProps {
  date: string | Date;
  price: number;
}

export interface CoinGeckoSimplePriceParams {
  ids: string;
  vs_currencies: string;
  include_market_cap?: boolean;
  include_24hr_vol?: boolean;
  include_24hr_change?: boolean;
  include_last_updated_at?: boolean;

}

export interface UserAddressParams {

  user_id: string;
  country_id: string;
  address_1: string;
  address_2?: string;
  city: string;
  postal_code: string;

}

export interface BuySellTransactionsParameters {
  page?: number;
  limit?: number;
}
interface BuySellTransactionsResponseMeta {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

interface BuySellTransactionResponseLinks {
  first: string;
  previous: string;
  next: string;
  last: string;
}

export interface BuySellTransactionsResponse {
  items: any[];
  meta: BuySellTransactionsResponseMeta;
  links: BuySellTransactionResponseLinks;

}

export enum MoonPayPaymentMethod {
  ach_bank_transfer = 'ach_bank_transfer',
  credit_debit_card = 'credit_debit_card',
  gbp_bank_transfer = 'gbp_bank_transfer',
  gbp_open_banking_payment = 'gbp_open_banking_payment',
  mobile_wallet = 'mobile_wallet',
  sepa_bank_transfer = 'sepa_bank_transfer',
  sepa_open_banking_payment = 'sepa_open_banking_payment',
  pix_instant_payment = 'pix_instant_payment'

}

export interface MoonPayBuySellQuoteParams {
  quoteCurrencyCode: string;
  baseCurrencyCode: string;
  baseCurrencyAmount?: number;
  quoteCurrencyAmount?: number;
  extraFeePercentage?: number;
  paymentMethod?: MoonPayPaymentMethod;
  areFeesIncluded?: boolean;
  fixed?: boolean;
  regionalPricing?: boolean;
}

export interface CashoutValidateResponse {

  status: string;
  address_verified: string;
  cash_out_scope: string;
}

export interface CashoutResponse {
  id: string; // this is the ebioro api internal transaction;
  kind: string; // this will be withdrawal
  withdraw_anchor_account: string; // this is the account where the asset needs to be sent
  withdraw_memo: string // this is the withdrawal memo that needs to be added to the transaction
  withdraw_memo_type: string // the memo type
  from: string; // the account from which the funds will be withdrawn. This will map the account of the wallet
  status: string; // the status of the transaction
  amount_in: number // this is the amount the wallet will transfer
  message: string // A general message for the user
}

export interface CashoutRequest {
  amount: number;
  asset_code: string;
}

export interface CashoutTransactionsParameters {
  page?: number;
  limit?: number;
}
interface CashOutTransactionsResponseMeta {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;

}

interface CashOutResponseLinks {
  first: string;
  previous: string;
  next: string;
  last: string;
}

export interface CashoutTransactionsResponse {
  items: any[];
  meta: CashOutTransactionsResponseMeta
  links: CashOutResponseLinks

}

export interface CashoutTransactionDelegateParameters extends DelegateSigningParams {

  id: string;

}

export enum CashoutTransactionStatus {

  pending_user_transfer_start = 'pending_user_transfer_start',
  pending_user_transfer_complete = 'pending_user_transfer_complete',
  pending_user = 'pending_user',
  failed = 'failed',
  completed = 'completed',
  processing = 'processing'

}

type PhoneNumberTypes =
	| 'fixed-line'
	| 'fixed-line-or-mobile'
	| 'mobile'
	| 'pager'
	| 'personal-number'
	| 'premium-rate'
	| 'shared-cost'
	| 'toll-free'
	| 'uan'
	| 'voip'
	| 'unknown'

type PhoneNumberPossibility =
| 'is-possible'
| 'invalid-country-code'
| 'too-long'
| 'too-short'
| 'unknown'

export interface ParsedPhoneNumberValid {
	valid: true;

	number: {
		input: string;
		international: string;
		national: string;
		e164: string;
		rfc3966: string;
		significant: string;
	};
	possibility: PhoneNumberPossibility;
	regionCode: string;
	possible: boolean;
	canBeInternationallyDialled: boolean;
	type: PhoneNumberTypes;
	countryCode: string;
	typeIsMobile: boolean;
	typeIsFixedLine: boolean;
}

export interface Contact {
  phoneNumber:ParsedPhoneNumber;
  name:string;
}

export interface TopUpLookUpParameters {
  accountNumber: string;
}

export interface TopUpContact {
  phone_number:string;
  contact_name?:string;

}

export interface TopUpProvider {

  id: string;
  createdAt: string;
  updatedAt: string;
  provider_code: string;
  country_iso: string;
  name: string;
  short_name: string | null;
  validation_regex: string;
  customer_care_number: string;
  region_codes: any[];
  payment_types: any[];
  logo_url: string;
  processing_transfers?:boolean

}

export interface TopUpLookUpResponse {

  providers:TopUpProvider[];
  country_iso:string;
  account_number_normalized:string;

  // id: string;
  // createdAt: string;
  // updatedAt: string;
  // provider_code: string;
  // country_iso: string;
  // name: string;
  // short_name: string | null;
  // validation_regex: string;
  // customer_care_number: string;
  // region_codes: any[];
  // payment_types: any[];
  // logo_url: string;
  // processing_transfers?:boolean
}

export interface getTopupProductsParameters {
  provider_code: string;
  region_code: string;
}

export interface ProductPriceInfo {

    CustomerFee: number;
    DistributorFee: number;
    ReceiveValue: number;
    ReceiveCurrencyIso: string;
    ReceiveValueExcludingTax: number;
    TaxRate: number;
    SendValue: number;
    SendCurrencyIso: string;
}

export interface ProductPriceObject {
  Price:ProductPriceInfo;
  SkuCode:string;
  BatchItemRef:string;
  ResultCode:string;
  ErrorCodes:any[];                
}

export interface ProductDescription {
  id:string;
  createdAt:string;
  updatedAt:string;
  display_text:string;
  description_markdown:string;
  read_more_markdown:string;
  localization_key:string;
  language_code:string;
}

export interface TopUpProduct{

  id: string;
  createdAt: string;
  updatedAt: string;
  provider_code: string;
  sku_code: string;
  localization_key: string;
  settings_definitions: any[];
  maximum: ProductPriceInfo;
  minimum: ProductPriceInfo;
  comission_rate: string;
  processing_mode: string;
  redemption_mechanism: string;
  benefits: any[];
  validity_period_iso: string | null;
  uat_number: string;
  additional_information: any;
  default_display_text: string;
  region_code: string;
  payment_types: any[];
  lookup_bills_required: boolean;
  descriptions:ProductDescription[]
}

export interface getTopUpProviderStatus {
  provider_codes:string;
}

export interface getTopUpProviderResponse {
  ProviderCode:string;
  IsProcessingTransfers:true;
  Message:string;
}

export interface getTopUpPromotionParameters {
  provider_code:string;
  currency_iso:string;
}

export interface getTopUpPromotionResponse {
  id:string;
  createdAt:string;
  updatedAt:string;
  provider_code:string;
  start_utc:string;
  end_utc:string;
  currency_iso:string;
  validity_period_iso:string|null;
  minimum_send_amount:string;
  localization_key:string;
  descriptions:TopUpPromotionDescription[]

}

export interface TopUpPromotionDescription {
  id:string;
  createdAt:string;
  updatedAt:string;
  dates:string;
  headline:string;
  terms_and_conditions:string;
  bonus_validity:string;
  promotion_type:string;
  localization_key:string;
  language_code:string;
  send_amounts:TopUpDescriptionSendAmount[];
  
}

interface TopUpBonus {
  Quantity:number;
  Validity:number;
  BonusType:number;
}

interface TopUpDescriptionSendAmount {
  Bonuses:TopUpBonus[];
  Maximum:number;
  Minimum:number;
}

export interface TopUpPriceObject {
  Product: TopUpProduct,
  Promotions:getTopUpPromotionResponse[],
  Price: ProductPriceInfo,
  UsdcDisplayPrice:number,
  UsdcDisplayCustomerFee:number,
  valid_promotion?:boolean
}

export interface TopUpCreateRequestParameters {

  sku_code:string;
  send_value:number;
  send_currency_iso:string;
  
  amount_in:number;
  fee_value:number;
  asset_code: string;
  asset_issuer?:string;
  
  account_number:string;
  
  reciever_full_name?:string;

}

export interface TopUpCreateResponse {
  withdraw_anchor_account:string;
  id:string;
}

export interface TopUpSendRequestParameters {
  uri:string;
  asset_code:string;
  account:string;
  id:string;
}

export interface TopUpsTransactionsParameters {
  page?: number;
  limit?: number;
}

export interface TopUpsTransactionsResponse {
  items: any[];
  meta: CashOutTransactionsResponseMeta
  links: CashOutResponseLinks

}

export interface EmailTokenRequestParameters {
  email:string;
  locale?:string;
}

export interface EmailTokenVerificationParameters {
  email:string;
  tokenId:string;
  code:string;
  auth_token:string;
}

export interface PhoneTokenRequestParameters {
  email:string;
  mobile:string;
  auth_token:string;
}

export interface PhoneTokenVerificationParameters {
  tokenId:string;
  code:string;
  email:string;
  mobile:string;
  auth_token:string;
}

export interface UserEmailPhoneRegistrationResponse {
  message:string;
  auth_token:string;
}

export interface UserRegistrationParameters {
  first_name:string;
  last_name:string;
  email:string;
  is_email_verified:boolean;
  mobile_number:string;
  is_mobile_number_verified:boolean;
  calling_code:string;
  auth_token:string;
  stellar_account:string;
  txEnvelope:string;
}

export interface UserRegistrationResponse {
  
  id:string;
  status:string;
}

export interface UserRegistrationStatusRequestParameter {
  id:string;
}

export interface WalletKeysRegistrationParameters {
  keys:EncryptedKey[]
}

export interface WalletRegistrationResponse {
  success:boolean
}

interface apiRootTimeZoneObject {
  name:string;
  offset:number;
  current_time:string;
  current_time_unix:number;
  is_dst:false;
  dst_savings:number;
}

interface apiRootCurrencyObject {
  code:string;
  name:string;
  symbol:string;
}

export interface apiRootResponse {
  ip:string;
  continent_code:string;
  continent_name:string;
  country_code2:string;
  country_code3:string;
  country_name:string;
  country_capital:string;
  state_prov:string;
  district:string;
  city:string;
  zipcode:string;
  latitude:string;
  longitude:string;
  is_eu:boolean;
  calling_code:string;
  country_tld:string;
  languages:string;
  country_flag:string;
  geoname_id:string;
  isp:string;
  connection_type:string;
  organization:string;
  asn:string;
  currency:apiRootCurrencyObject;
  time_zone:apiRootTimeZoneObject;
}

export interface WalletRecoveryPhoneRequestParameters {
  mobile:string;
  locale?:string;

}

export interface WalletRecoveryEmailRequestParameters {
  email:string;
  locale?:string;

}

export interface WalletRecoveryRequestResponse {
  
  partial_token: string,
}

export interface WalletRecoveryPhoneVerifyRequestParameters {
  tokenId:string;
  code:string;
  mobile:string;
  auth_token:string

}

export interface WalletRecoveryEmailVerifyRequestParameters {
  tokenId:string;
  code:string;
  email:string;
  auth_token:string

}

export interface WalletKeyRecoveryParameters {
  auth_token:string;
}

// export interface WalletKeyRecoveryResponse {
//   encrypedKeys:EncryptedKey[]
// }


export interface DocumentTransactionParameters {
  asset_code: string;
  start_date: string;
  end_date: string;
  user_id?:string;
}

export enum DocumentTransactionStatus {
  completed = 'completed',
  pending = 'pending',
  error = 'error'
}



export interface DocumentTransactionResponse {

  id:string;
  createdAt:string;
  updatedAt:string;
  file_name:string;
  user_id:string;
  transactions:any[];
  status:DocumentTransactionStatus;

}

interface AccountStatementsResponseResponseLinks {
  first: string;
  previous: string;
  next: string;
  last: string;
}

interface AccountStatementsResponseMeta {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;

}

export interface AccountStatementsResponse {
  items: DocumentTransactionResponse[];
  meta: AccountStatementsResponseMeta
  links: AccountStatementsResponseResponseLinks

}












export interface EmailTokenRequestParameters {
  email:string;
  locale?:string;
}

export interface PhoneTokenRequestParameters {
  email:string;
  mobile:string;
  auth_token:string;
}

export interface PhoneTokenVerificationParameters {
  tokenId:string;
  code:string;
  email:string;
  mobile:string;
  auth_token:string;
}

export interface UserEmailPhoneRegistrationResponse {
  message:string;
  auth_token:string;
}

export interface UserRegistrationParameters {
  first_name:string;
  last_name:string;
  email:string;
  is_email_verified:boolean;
  mobile_number:string;
  is_mobile_number_verified:boolean;
  calling_code:string;
  auth_token:string;
  stellar_account:string;
  txEnvelope:string;
}

export interface UserRegistrationResponse {
  
  id:string;
  status:string;
}

export interface UserRegistrationStatusRequestParameter {
  id:string;
}

export interface WalletKeysRegistrationParameters {
  keys:EncryptedKey[]
}

export interface WalletRegistrationResponse {
  success:boolean
}

interface apiRootTimeZoneObject {
  name:string;
  offset:number;
  current_time:string;
  current_time_unix:number;
  is_dst:false;
  dst_savings:number;
}

interface apiRootCurrencyObject {
  code:string;
  name:string;
  symbol:string;
}

export interface apiRootResponse {
  ip:string;
  continent_code:string;
  continent_name:string;
  country_code2:string;
  country_code3:string;
  country_name:string;
  country_capital:string;
  state_prov:string;
  district:string;
  city:string;
  zipcode:string;
  latitude:string;
  longitude:string;
  is_eu:boolean;
  calling_code:string;
  country_tld:string;
  languages:string;
  country_flag:string;
  geoname_id:string;
  isp:string;
  connection_type:string;
  organization:string;
  asn:string;
  currency:apiRootCurrencyObject;
  time_zone:apiRootTimeZoneObject;
}

export interface WalletRecoveryPhoneRequestParameters {
  mobile:string;
  locale?:string;

}

export interface WalletRecoveryRequestResponse {
  
  message:string;
  auth_token:string;
}

export interface WalletRecoveryPhoneVerifyRequestParameters {
  tokenId:string;
  code:string;
  mobile:string;
  auth_token:string

}

export interface WalletKeyRecoveryParameters {
  auth_token:string;
}

export interface WalletKeyRecoveryResponse {
  encrypedKeys:EncryptedKey[]
}


export interface AccountStamentsParameters {
  page?: number;
  limit?: number;
  user_id:string;
}

 export interface PageLinks {
  first: string,
  previous: string,
  next: string,
  last: string
}

export interface ContactsInPlatformResponse {
  id:string,
  first_name:string,
  last_name:string,
  email:string,
  mobile_number:string,
  email_federation_address:string,
  mobile_federation_address:string,
  payment_link:string,
  stellar_account: {
    public_key: string
  }
}

export interface BeneficiaryResponse {
  id: string;
  createdAt:string;
  updatedAt:string;
  type: string;
  bank_country?: string | null;
  currency?:string|null;
  first_name?: string | null;
  last_name?: string|null;
  second_last_name?:string|null;
  bank_code?: string | null;
  bank_name?:string |null;
  address?: string | null;
  municipality?: string | null;
  province?: string | null;
  national_id?: string | null;
  account_number?: string | null;
  account_type:string;
  payment_id?:string |null;
  payment_id_name?:string | null;
  stellar_account?:string;
  phone_number:string|null;
  memo?:string;
  memo_type?:string;

}

export interface BeneficiaryRequestParams {
  id?:string;
  type?:string;
  account_type?:string;
  user_id?: string;
  bank_country?:string;
  bank_name?:string |null;
  bank_code?:string;
  currency?: string;
  first_name?:string ;
  last_name?:string ;
  second_last_name?:string;
  address?:string ;
  province?:string ;
  municipality?:string;
  national_id?:string;
  account_number?:string;
  payment_id?: string;
  payment_id_name?:string;
  stellar_account?:string;
  bank_branch_code?:string;
  phone_number?:string;
  memo?:string;
  memo_type?:string;
 
}

export interface BankTransferCreateRequestParams {

  sender_id:string;
  beneficiary_id:string;
  amount:number;
  asset:string;
  fees:number;

}

export interface BankTransferCreateResponse {
  id:string,
  receiving_anchor_account:string,
  memo:string,
  memo_type:string
}

export interface BankTransferSendRequestParams {
    uri: string;
    asset_code:string;
    asset_issuer?:string;
    account:string;
    id: string;
}

export enum CustodialOperationTypes {
  bank_transfer="bank_transfer",
  topup="topup",
  giftcard="giftcard",
  lanave="lanave"
}

export interface LaNavePromotionResponse {
  name: string;
  usd_currency_amount:number;
  cup_currency_amount:number;
  promo_fee:number;
}

export interface LaNaveUserValidateRequestParameters {

  phone_number:string;
  user_type:string;
}

export interface LaNaveUserValidateResponse{
  valid:boolean

}

export interface LaNaveTopUpCreateRequestParameters {

  sku_code:string; // this is the denomination.
  phone_number:string;
  user_type:string; // USER or PROVIDER
  amount_in:number; // amount the user needs to pay. Including fees;
  asset_code:string; // i.e. USDC
  asset_issuer?:string;
  fee_value:number;
  reciever_full_name?:string;
  buy_amount:number; // the amount the user buys in CUP ;
}

export enum CrypToProviders {

  moonPay='moonPay'
}

export type PaymentLinkRequest ={
  paymentLink:string;
  amount:string;
  asset_code:string;
  asset_issuer:string;
  message:string;

}

export type PaymentLinkResponse ={
  paymentLink:string;
}

export type CreateWalletRequest ={
  chain:'stellar';
  identityProof:cs.IdentityProof;
  external_id:string;
  account_key:string;
}

export type CreateWalletRequestResponse ={
    id: string;
    ownerId: string;
    address: string;
    chain_type: string;
}


